import {
	MimaButton,
	MimaText,
	Modal,
	PageLoader,
	MimaTextArea,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { Formik } from 'formik';
import React from 'react';

const ActionPayroll = ({
	closeModal,
	details,
	validationSchema,
	onSubmit,
	loading,
}) => {
	const { status } = details;
	const detailsLength = details.ids?.length || 0;
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			{loading ? (
				<PageLoader title="while we fetch your records" loading={loading} />
			) : (
				<div className={styles.gp}>
					<MimaText variant="subtitle" align="center" mb={4} width={38}>
						{status === 'Void' ? 'Void' : 'Ignore'} Payroll
					</MimaText>
					<MimaText align="center" mb={2} width={38}>
						{`Set ${detailsLength} ${detailsLength > 1 ? 'Employees' : 'Employee'} to ${status} State`}
					</MimaText>

					<Formik
						initialValues={{
							comment: '',
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}
					>
						{({
							handleSubmit,
							handleChange,
							handleBlur,
							values,
							errors,
							touched,
						}) => (
							<>
								<MimaTextArea
									type="textarea"
									labelTitle="Comment"
									placeholder="Enter Comment"
									name="comment"
									mb={2}
									variant="message"
									error={errors.comment}
									touched={touched.comment}
									value={values.comment}
									onChange={handleChange}
									onBlur={handleBlur}
								/>

								<MimaButton
									title="Submit"
									onClick={handleSubmit}
									type="submit"
									loading={loading}
									mt={2}
								/>
							</>
						)}
					</Formik>
				</div>
			)}
		</Modal>
	);
};

export default ActionPayroll;
